// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1kAh0","containerItemsCenter":"Skeleton_containerItemsCenter__3RtA3"};